module.exports = __webpack_public_path__ + "static/media/05.41075a1c.png";